(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientStatusDialogController', PatientStatusDialogController);

    PatientStatusDialogController.$inject = ['$timeout', '$scope', '$state', '$stateParams', '$uibModalInstance', 'patientStatus',
        'PatientStatus', 'Patient'];

    function PatientStatusDialogController ($timeout, $scope, $state, $stateParams, $uibModalInstance,
                                            patientStatus, PatientStatus, Patient) {
        var vm = this;

        vm.patientStatus = patientStatus;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.editing = $state.current.name != "patient-status.view";

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.patientStatus.id !== null) {
                PatientStatus.update(vm.patientStatus, onSaveSuccess, onSaveError);
            } else {
                PatientStatus.save(vm.patientStatus, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:patientStatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
